// Portal v2 Slice C1 — account settings API client.
import { api } from "@/lib/api";

export interface PortalAccount {
  name: string;
  email: string;
  company: string | null;
}

export async function fetchPortalAccount(): Promise<PortalAccount> {
  return api<PortalAccount>("/portal/account");
}

export async function updatePortalAccountName(
  name: string,
): Promise<PortalAccount> {
  return api<PortalAccount>("/portal/account", {
    method: "PATCH",
    body: JSON.stringify({ name }),
  });
}

/** Resolves on success. Afterwards every session is signed out server-side
 *  (this device included) — callers must clear local auth and route to
 *  sign-in. */
export async function changePortalPassword(args: {
  currentPassword: string;
  newPassword: string;
}): Promise<void> {
  await api("/portal/account/password", {
    method: "POST",
    body: JSON.stringify({
      current_password: args.currentPassword,
      new_password: args.newPassword,
    }),
  });
}
